module.exports = {
      id: "play-games-usage",
      viewBox: "0 0 529 386",
      url: __webpack_public_path__ + "svg-sprite-ef426a51ffa8e0d9106d678bb4289730.svg#play-games",
      toString: function () {
        return this.url;
      }
    }